const rightArrow = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 1200 1200">
  <path d="M599.94 1199.88c330.8 0 599.94-269.13 599.94-599.94C1199.88 269.14 930.75 0 599.94 0 269.14 0 0 269.13 0 599.94c0 330.8 269.13 599.94 599.94 599.94zm0-1170.61c314.68 0 570.67 256 570.67 570.67 0 314.68-256 570.67-570.67 570.67-314.68 0-570.67-256-570.67-570.67 0-314.68 256-570.67 570.67-570.67z"/>
  <path d="M504.16 868.96a14.62 14.62 0 0 0 20.69 0l258.67-258.68a14.62 14.62 0 0 0 0-20.7L524.84 330.92a14.59 14.59 0 0 0-20.7 0 14.62 14.62 0 0 0 0 20.69L752.5 599.93 504.16 848.26a14.62 14.62 0 0 0 0 20.69z"/>
</svg>
`

const leftArrow = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 1200 1200">
  <path d="M599.94 1199.88C269.14 1199.88 0 930.75 0 599.94 0 269.14 269.13 0 599.94 0c330.8 0 599.94 269.13 599.94 599.94 0 330.8-269.13 599.94-599.94 599.94zm0-1170.61c-314.68 0-570.67 256-570.67 570.67 0 314.68 256 570.67 570.67 570.67 314.68 0 570.67-256 570.67-570.67 0-314.68-256-570.67-570.67-570.67z"/>
  <path d="M695.72 868.96a14.62 14.62 0 0 1-20.69 0L416.36 610.28a14.62 14.62 0 0 1 0-20.7l258.68-258.67a14.59 14.59 0 0 1 20.7 0 14.62 14.62 0 0 1 0 20.69L447.39 599.93l248.33 248.33a14.62 14.62 0 0 1 0 20.69z"/>
</svg>
`

jQuery(document).ready(function() {
  jQuery('.slider-for').slick({
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    swipeToSlide: true,
    fade: true,
    asNavFor: '.slider-nav',
    prevArrow: `
      <button class="btn btn-action btn-fullscreen slick-prev slick-arrow">
        ${leftArrow}
      </button>`,
    nextArrow: `
      <button class="btn btn-action btn-fullscreen slick-next slick-arrow">
        ${rightArrow}    
      </button>`,
  })
  
  if (jQuery('.slider-nav').children().length > 0) {
    jQuery('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      swipeToSlide: true,
      arrows: false,
      infinite: true,
      centerMode: jQuery('.slider-nav').children().length > 2 ? true : false,
      accessibility: false,
      focusOnSelect: true,
      adaptiveHeight: true
    })
  }

  jQuery(document).on('click', '.slider.slider-main .view-fullscreen', function (e) {
    e.preventDefault()
    e.stopPropagation()

    let images = [],
      currentSlideIndex = 0

    let sliderNav = jQuery('.slider-main').find('.view-fullscreen')

    sliderNav.each(function () {
      let slideThumb = jQuery(this).find('.slider-image-inner').clone()

      if (jQuery(this).parents('.slick-slide.slick-active').length) {
        currentSlideIndex = jQuery(this).parents('.slick-slide.slick-active').data('slick-index')
      }

      images.push({
        slideThumbData: slideThumb,
        slideFullscreenUrl: jQuery(this).attr('href'),
      })
    })

    setFullscreenGallery(images, currentSlideIndex)
  })
})

function setFullscreenGallery(images, current) {
  if (images?.length === 0) return

  let template = jQuery(`
    <div class="slick-fullscreen slick-fullscreen-closed">
      <div class="slick-fullscreen-container"></div>
      <div class="slick-fullscreen-thumbs">
        <div class="slick-thumbs-wrapper"></div>
      </div>

      <div class="slick-fullscreen-actions">
        <button class="btn btn-action btn-fullscreen btn-fullscreen-close">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 1200 1200">
            <path d="M599.29 17C920.9 17 1183 277.68 1183 599.29 1183 920.9 920.9 1183 599.29 1183S17 920.9 17 599.29 277.68 17 599.29 17zm-211.1 345.69c-17-17-42.5 8.5-25.5 25.5l211.1 211.1-211.1 211.1c-17 18.42 8.5 43.92 25.5 26.92l211.1-211.1 211.1 211.1c18.42 17 43.92-8.5 26.92-26.92l-211.1-211.1 211.1-211.1c17-17-8.5-42.5-26.92-25.5l-211.1 211.1zm211.1-317.36c-306.02 0-553.96 247.93-553.96 553.96 0 306.02 247.93 555.37 553.96 555.37 306.02 0 555.37-249.35 555.37-555.37S905.31 45.33 599.29 45.33z"/>
          </svg>
        </button>

        <button class="btn btn-action btn-fullscreen btn-fullscreen-prev">
          ${leftArrow}
        </button>

        <button class="btn btn-action btn-fullscreen btn-fullscreen-next">
          ${rightArrow}     
        </button>
      </div>
    </div>
  `)

  let mainContainer = template
  let zoomContainer = template.find('.slick-fullscreen-container')
  let thumbContainer = template.find('.slick-thumbs-wrapper')
  let activeFullscreenImage = null

  images.forEach((thumb, i) => {
    let img = images[i]

    jQuery('<button class="btn btn-action btn-fullscreen-thumb">')
      .data('fullscreen-url', img.slideFullscreenUrl)
      .html(img.slideThumbData)
      .appendTo(thumbContainer)
  })

  if (images?.length === 1) {
    mainContainer.addClass('slick-fullscreen-single')
  }

  const slickFullscreenTrigger = function slickFullscreenTrigger(inputX, inputY) {
    let doPanX = activeFullscreenImage.width() > mainContainer.width()
    let doPanY = activeFullscreenImage.height() > mainContainer.height()

    if (doPanX || doPanY) {
      let midX = mainContainer.width() / 2
      let midY = mainContainer.height() / 2
      let finalOffsetX = 0
      let finalOffsetY = 0
      let offsetFromCentreX = inputX - midX,
        offsetFromCentreY = inputY - midY

      if (doPanX) {
        let offsetMultiplierX = (activeFullscreenImage.width() - mainContainer.width()) / 2 / midX

        finalOffsetX = Math.round(-offsetFromCentreX * offsetMultiplierX)
      }

      if (doPanY) {
        let offsetMultiplierY = (activeFullscreenImage.height() - mainContainer.height()) / 2 / midY

        finalOffsetY = Math.round(-offsetFromCentreY * offsetMultiplierY)
      }

      activeFullscreenImage.css('transform', `translate3d(${finalOffsetX}px, ${finalOffsetY}px, 0)`)
    }
  }

  mainContainer.on('click.slickFullscreen select.slickFullscreen', '.btn-fullscreen-thumb', function (e) {
    e.preventDefault()

    jQuery(this)
      .addClass('btn-fullscreen-thumb-active')
      .siblings('.btn-fullscreen-thumb-active')
      .removeClass('btn-fullscreen-thumb-active')

    activeFullscreenImage = jQuery(
      '<img class="slick-fullscreen-container-image" alt="" style="visibility: hidden" />'
    )
    activeFullscreenImage
      .on('load', function () {
        jQuery(this).off('load')
        jQuery(this).css({
          visibility: '',
          top: mainContainer.height() / 2 - jQuery(this).height() / 2,
          left: mainContainer.width() / 2 - jQuery(this).width() / 2,
        })

        slickFullscreenTrigger(e.clientX, e.clientY)
      })
      .attr('src', jQuery(this).data('fullscreen-url'))
    zoomContainer.html(activeFullscreenImage)
  })

  mainContainer.on('mousemove.slickFullscreen touchmove.slickFullscreen', function (e) {
    if (e.type === 'touchmove') {
      let touch = e.touches[0]

      slickFullscreenTrigger(touch.clientX, touch.clientY)
    } else {
      slickFullscreenTrigger(e.clientX, e.clientY)
    }
  })

  mainContainer.on('touchmove.slickFullscreen', '.slick-thumbs-wrapper', function (e) {
    e.stopPropagation()
  })

  mainContainer.on('click.slickFullscreen', '.btn-fullscreen-next', function (e) {
    e.preventDefault()

    let $next = thumbContainer.find('.btn-fullscreen-thumb-active').next()

    if ($next.length === 0) {
      $next = thumbContainer.find('.btn-fullscreen-thumb:first')
    }

    $next.trigger('select')
  })

  mainContainer.on('click.slickFullscreen', '.btn-fullscreen-prev', function (e) {
    e.preventDefault()

    let $prev = thumbContainer.find('.btn-fullscreen-thumb-active').prev()

    if ($prev.length === 0) {
      $prev = thumbContainer.find('.btn-fullscreen-thumb:last')
    }

    $prev.trigger('select')
  })

  jQuery(document).on('keyup.slickFullscreen', function(e) {
    let activeItemClass = 'btn-fullscreen-thumb-active'
    let activeItem = jQuery(`.btn-fullscreen-thumb.${activeItemClass}`)

    if (activeItem.length > 0) {
      if (e.key === 'Backspace') {
        mainContainer.find('.btn-fullscreen-close').trigger('click')
      }

      if (e.key === 'Escape') {
        mainContainer.find('.btn-fullscreen-close').trigger('click')
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault()
  
        let prev = activeItem.prev('button.btn-fullscreen-thumb')
  
        if (prev.length == 0) {
          prev = $(activeItem).siblings('.btn-action.btn-fullscreen-thumb:last')
        }
  
        jQuery(prev).trigger('click')
      } else if (e.key === 'ArrowRight') {
        e.preventDefault()
  
        let next = activeItem.next('.btn-action.btn-fullscreen-thumb');
  
        if (next.length == 0) {
          next = $(activeItem).siblings('.btn-action.btn-fullscreen-thumb:first')
        }

        jQuery(next).trigger('click')
      }
    }
  })

  mainContainer.on('click.slickFullscreen', '.btn-fullscreen-close', function (e) {
    e.preventDefault()

    mainContainer.off('.slickFullscreen')
    mainContainer.addClass('slick-fullscreen-closed')

    let transitionDelay = mainContainer.css('transition-duration')

    transitionDelay =
      transitionDelay.indexOf('ms') > -1 ? parseFloat(transitionDelay) : parseFloat(transitionDelay) * 1000

    setTimeout(function () {
      mainContainer.remove()
      jQuery('html').removeClass('slick-fullscreen-open')
      window.history.back()
    }, transitionDelay)
  })

  function refreshOnResize() {
    let activeItem = thumbContainer.find('.btn-fullscreen-thumb-active')

    activeItem.trigger('select')
  }

  let refresh

  jQuery(window).on('resize.slickFullscreen', function () {
    clearTimeout(refresh)

    refresh = setTimeout(refreshOnResize, 100)
  })

  jQuery('html').removeClass('slick-fullscreen-open')
  jQuery('.slick-fullscreen').remove()

  jQuery('html').addClass('slick-fullscreen-open')

  template.appendTo('body')

  thumbContainer.find('.btn-fullscreen-thumb:eq(' + (current > 0 ? current : 0) + ')').trigger('select')

  setTimeout(function () {
    mainContainer.removeClass('slick-fullscreen-closed')
  }, 100)
}
